import { render, staticRenderFns } from "./uploadFiles.vue?vue&type=template&id=5b1f057c"
import script from "./uploadFiles.ts?vue&type=script&lang=js&external"
export * from "./uploadFiles.ts?vue&type=script&lang=js&external"
import style0 from "./uploadFiles.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports